import React from 'react';
import { ExternalLink } from 'lucide-react';

const InstagramReelsSection = () => {
  return (
    <section id="tips" className="py-24 bg-section">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="heading-1 mb-4">Consejos para el cuidado de tu piel</h2>
          <p className="body-large text-secondary max-w-2xl mx-auto">
            Descubre los últimos consejos profesionales y insights para mantener 
            una piel saludable y radiante, directamente desde mis redes sociales.
          </p>
        </div>

        {/* Instagram Profile Image */}
        <div className="flex justify-center mb-16">
          <a 
            href="https://www.instagram.com/adrian.cuellar.derma/"
            target="_blank"
            rel="noopener noreferrer"
            className="relative group hover-lift cursor-pointer"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_derma-centro/artifacts/edy8fnjj_Screenshot%202025-11-05%20at%2010.38.38%E2%80%AFa.m..png"
              alt="Dr. Adrián Cuéllar - Instagram Profile"
              className="w-full max-w-2xl rounded-2xl shadow-2xl transition-transform duration-300 group-hover:scale-[1.02]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl flex items-center justify-center">
              <div className="bg-white/90 backdrop-blur-sm rounded-full p-4 shadow-lg">
                <ExternalLink size={32} className="text-accent-purple-500" />
              </div>
            </div>
          </a>
        </div>

        {/* Follow Instagram & TikTok CTAs */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto mt-16">
          {/* Instagram CTA */}
          <div className="voice-card accent-purple p-8">
            <div className="mb-4">
              <svg className="w-12 h-12 mx-auto text-accent-purple-400" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12.017 0C8.396 0 8.025.015 6.782.072 5.537.129 4.67.345 3.918.639c-.818.319-1.513.742-2.205 1.434C.321 2.765-.102 3.46-.421 4.278c-.294.752-.51 1.619-.567 2.864C-.015 8.385 0 8.756 0 12.377s.015 3.99.072 5.233c.057 1.245.273 2.112.567 2.864.319.818.742 1.513 1.434 2.205.692.692 1.387 1.115 2.205 1.434.752.294 1.619.51 2.864.567 1.243.057 1.614.072 5.235.072s3.99-.015 5.233-.072c1.245-.057 2.112-.273 2.864-.567.818-.319 1.513-.742 2.205-1.434.692-.692 1.115-1.387 1.434-2.205.294-.752.51-1.619.567-2.864.057-1.243.072-1.614.072-5.235s-.015-3.99-.072-5.233c-.057-1.245-.273-2.112-.567-2.864-.319-.818-.742-1.513-1.434-2.205C19.513.742 18.818.319 18 0c-.752-.294-1.619-.51-2.864-.567C13.993-.015 13.622 0 12.001 0h.016zm.983 1.801c.085 0 .18.001.295.001 3.996 0 4.47.015 6.056.071 1.462.067 2.257.311 2.785.516.7.272 1.2.597 1.725 1.122.525.525.85 1.025 1.122 1.725.205.528.449 1.323.516 2.785.056 1.586.071 2.06.071 6.056s-.015 4.47-.071 6.056c-.067 1.462-.311 2.257-.516 2.785-.272.7-.597 1.2-1.122 1.725-.525.525-1.025.85-1.725 1.122-.528.205-1.323.449-2.785.516-1.586.056-2.06.071-6.056.071s-4.47-.015-6.056-.071c-1.462-.067-2.257-.311-2.785-.516-.7-.272-1.2-.597-1.725-1.122-.525-.525-.85-1.025-1.122-1.725-.205-.528-.449-1.323-.516-2.785-.056-1.586-.071-2.06-.071-6.056s.015-4.47.071-6.056c.067-1.462.311-2.257.516-2.785.272-.7.597-1.2 1.122-1.725.525-.525 1.025-.85 1.725-1.122.528-.205 1.323-.449 2.785-.516 1.586-.056 2.06-.071 6.056-.071zm0 3.093c-2.84 0-5.143 2.303-5.143 5.143s2.303 5.143 5.143 5.143 5.143-2.303 5.143-5.143-2.303-5.143-5.143-5.143zm0 8.476c-1.84 0-3.333-1.493-3.333-3.333s1.493-3.333 3.333-3.333 3.333 1.493 3.333 3.333-1.493 3.333-3.333 3.333zm6.532-8.683c0 .664-.538 1.202-1.202 1.202s-1.202-.538-1.202-1.202.538-1.202 1.202-1.202 1.202.538 1.202 1.202z"/>
              </svg>
            </div>
            <h3 className="heading-3 mb-3 text-center">Sígueme en Instagram</h3>
            <p className="body-small text-secondary mb-6 text-center">
              Mantente al día con los últimos consejos de dermatología, tratamientos y resultados reales.
            </p>
            <a 
              href="https://www.instagram.com/adrian.cuellar.derma/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary w-full inline-flex items-center justify-center gap-2"
            >
              @adrian.cuellar.derma
              <ExternalLink size={16} />
            </a>
          </div>

          {/* TikTok CTA */}
          <div className="voice-card accent-pink p-8">
            <div className="mb-4">
              <svg className="w-12 h-12 mx-auto text-accent-pink-400" fill="currentColor" viewBox="0 0 24 24">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
              </svg>
            </div>
            <h3 className="heading-3 mb-3 text-center">Sígueme en TikTok</h3>
            <p className="body-small text-secondary mb-6 text-center">
              Contenido breve y entretenido sobre dermatología, tips rápidos y respuestas a tus dudas.
            </p>
            <a 
              href="https://www.tiktok.com/@adrian.cuellar.derma"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary w-full inline-flex items-center justify-center gap-2"
            >
              @adrian.cuellar.derma
              <ExternalLink size={16} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InstagramReelsSection;